<template>
    <div class="email-subscription-content">
        <div class="subscription-modal">
            <div class="picture-wrapper">
                <picture class="subscription-modal__image">
                    <template v-if="inline">
                        <img :src="'/img/subscribe-page.webp'" alt="Подписаться">
                    </template>
                    <template v-else-if="this.$store.state.settings.site_id === 1">
                        <source :srcset="'/img/popups1.webp'" type="image/webp">
                        <img :src="'/img/popups1.webp'" alt="Подписаться">
                    </template>
                    <template v-else>
                        <source :srcset="'/img/popups1.webp'" type="image/webp">
                        <img :src="'/img/popups1.webp'" alt="Subscribe">
                    </template>
                </picture>
            </div>
            <div v-if="showSuccessMessage" class="subscription-success">
                <h3 class="subscription-success__title">{{ trans('Thanks for subscribing') }}</h3>
                <h3 class="subscription-success__title">{{ trans('Check your email') }}</h3>
                <p class="subscription-success__text">{{ trans('The promo code is already there.') }}</p>
            </div>
            <template v-else>
            <div class="form-header">
                <template v-if="$store.state.settings.site_id === 1 && this.inline">
                    <h3 class="subscription-modal__title">{{ trans('Get -10% off your first order') }}</h3>
                </template>
                <template v-else-if="$store.state.settings.site_id === 1 && !this.inline">
                    <h3 class="subscription-modal__title">{{ trans('WE GIVE A -10% DISCOUNT') }}</h3>
                    <h3 class="subscription-modal__title">{{ trans('Receive a promo code upon subscription') }}</h3>
                </template>
                <template v-else-if="$store.state.settings.site_id === 2">
                    <h3 class="subscription-modal__title">{{ trans('Get -10% OFF') }}</h3>
                    <h3 class="subscription-modal__title">{{ trans('Receive a promo code upon subscription') }}</h3>
                </template>
            </div>
            <div class="form-desc">
                <template v-if="$store.state.settings.site_id === 1 && this.inline">
                    <p>
                        {{ trans('Subscribe to the newsletter and be the first to know about new drops and promotions.') }} <strong>{{ trans('Limited offer!') }}</strong>
                    </p>
                </template>
                <p
                    v-else-if="$store.state.settings.site_id === 1 && !this.inline"
                    v-html="trans('Stay updated on the latest news, exclusive offers, and upcoming collections. Receive personalized styling suggestions to enhance your wardrobe.')">
                </p>
                <template v-else-if="$store.state.settings.site_id === 2 && this.inline">
                    <p>
                        <span v-html="trans('To stay updated on the latest news, exclusive offers, and upcoming drops.')"></span> <strong>{{ trans('Limited offer. Hurry up.') }}</strong>
                    </p>
                </template>
                <p
                    v-else-if="$store.state.settings.site_id === 2 && !this.inline"
                    v-html="trans('Stay updated on the latest news, exclusive offers, and upcoming collections. Receive personalized styling suggestions to enhance your wardrobe.')">
                </p>
            </div>
            <form class="subscription-modal__form" style="margin-top: 20px;flex-direction:column;">
                <div class="input-wrapper">
                    <input
                        v-model="email"
                        type="text"
                        name="email"
                        :placeholder="emailPlaceholder"
                        class="input-element input-wrapper__element-inp input-wrapper__element-inp-js">
                </div>

                <div class="input-wrapper">
                    <div class="select-size">
                        <div
                            class="select-size__header input-wrapper__element-inp"
                            @click="show_gender = !show_gender"
                            :class="show_gender ? 'select-active':''">
                            <p class="select-size__header-title sex-select__title"
                               v-if="gender">
                                {{ gender === 1 ? trans('Male gender') : trans('Female gender') }}</p>
                            <p class="select-size__header-title sex-select__title placeholder"
                               v-if="!gender">{{ genderPlaceholder }}</p>
                            <img class="select-size__header-img" src="https://batnorton.com/img/svg/select-ar.svg"
                                 alt="">
                        </div>
                        <div class="select-size__body">
                            <ul class="list select-size__list" v-show="show_gender"
                                :class="show_gender ? 'select-size__body_displayed':''">
                                <li @click="setGender(1)" class="list__element select-size__element">
                                    <span class="select-size__element-value">{{ trans('Male gender') }}</span>
                                    <span class="select-size__element-value"></span>
                                </li>
                                <li @click="setGender(2)" class="list__element select-size__element">
                                    <span class="select-size__element-value">{{ trans('Female gender') }}</span>
                                    <span class="select-size__element-value"></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="input-wrapper" style="margin-top: 20px">
                    <label class="input-wrapper__title input-checkbox__wrapper subscribe-form__checkbox-title">
                        <input
                            v-model="checkbox"
                            type="checkbox"
                            class="input-checkbox"
                            name="agreement"
                            id="agreement">
                        <span
                            v-if="$store.state.settings.site_id === 1"
                            class="privacy"
                            v-html="trans('I agree to receive information about news, promotions, and special offers in accordance with the Privacy Policy.')">
                        </span>
                        <span v-else-if="$store.state.settings.site_id === 2" class="privacy">
                            {{ trans('I agree to receive news, updates, and special offers.') }}<br>
                            {{ trans('I have read and agree to the') }} <a href="/privacy-policy">{{ trans('Privacy Policy') }}</a>.
                        </span>
                    </label>
                </div>

                <button
                    :disabled="subscribeButton"
                    @click.prevent="subscribe"
                    style="max-height: 42px;"
                    class="btn btnV2 subscription-modal__button-js">
                    {{ trans('Get discount') }}
                </button>
            </form>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EmailSubscriptionContent',
    props: {
        inline: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['subscribed'],
    data() {
        return {
            email: '',
            checkbox: true,
            gender: null,
            show_gender: false,
            subscribeButton: false,
            subscribed: false,
            justSubscribed: false,
        }
    },
    mounted() {
        const data = JSON.parse(localStorage.getItem('email-subscription-air-1'))
        this.subscribed = data ? Boolean(data.subscribed) : false

        if (this.subscribed && this.inline) {
            this.$notify({
                title: this.trans('Notification'),
                text: this.trans('You have already subscribed'),
                type: 'success',
            })
        }
    },
    computed: {
        showSuccessMessage() {
            return this.inline && this.justSubscribed
        },
        emailPlaceholder() {
            if (this.$store.state.settings.site_id === 1 || this.$store.state.settings.site_id === 2) {
                return this.trans('EMAIL')
            }
            return 'email'
        },
        genderPlaceholder() {
            return this.trans('Gender')
        },
    },
    methods: {
        setGender(male) {
            this.gender = male
            this.show_gender = false
        },
        validateEmail() {
            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            return emailRegex.test(this.email)
        },
        async subscribe() {
            let errorsExists = false
            if (!this.gender) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Specify the gender'),
                    type: 'error',
                });
                errorsExists = true
            }
            if (!this.checkbox) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('You must agree to the terms and conditions'),
                    type: 'error',
                });
                errorsExists = true
            }
            if (this.email.length === 0) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Fill in the email'),
                    type: 'error',
                });
                errorsExists = true
            } else if (!this.validateEmail()) {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
                errorsExists = true
            }

            if (errorsExists === true) {
                return false
            }

            this.subscribeButton = true;

            await axios.get('/api/v1/set-subscribe', {
                params: this.setParam({
                    email: this.email,
                    guest: this.$store.state.settings.guest.id,
                    gender: this.gender,
                    type: 1
                })
            })
            .then(data => {
                if (data.data.status === 'success') {
                    localStorage.setItem('email-subscription-air-1', JSON.stringify({
                        'time': new Date().setFullYear(9999).toFixed(),
                        'subscribed': true
                    }))
                    this.subscribed = true
                    this.subscribeButton = false
                    const alreadySubscribed = data.data.text === this.trans('You have already subscribed')
                    if (this.inline) {
                        if (alreadySubscribed) {
                            this.$notify({
                                title: this.trans('Notification'),
                                text: data.data.text,
                                type: 'success',
                            })
                        } else {
                            this.justSubscribed = true
                        }
                    } else {
                        this.$notify({
                            title: this.trans('Notification'),
                            text: data.data.text,
                            type: 'success',
                        });
                        this.$emit('subscribed')
                    }
                }
                if (data.data.status === 'error') {
                    this.$notify({
                        title: this.trans('Error'),
                        text: data.data.text,
                        type: 'error',
                    });
                    this.subscribeButton = false
                }
            })
        }
    }
};
</script>

<style lang="scss">
.placeholder {
    color: #757575;
    line-height: 16px;
}
.subscription-modal__button-js {
    margin-top: 10px;
}
.privacy a {
    color: #3c3c3c;
    text-decoration: underline;
}
.email-subscription-content {
    .subscription-modal {
        padding: 0;
        .picture-wrapper {
            position: relative;
            margin: 20px 0 40px 0;
            .subscription-modal__title {
                font-size: 16px;
                color: white;
                text-align: center;
                font-weight: 400;
                text-transform: uppercase;
            }
        }
        .form-desc {
            margin-top: 20px;
        }
        .form-desc p {
            font-size: 12px;
            line-height: 16px;
            text-transform: uppercase;
        }
        .subscription-modal__title {
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            font-weight: 510;
        }
        .subscription-modal__form {
            .input-wrapper__element-inp {
                background-color: #DFDEDE;
            }
            .subscribe-form__checkbox-title {
                text-transform: none;
                font-size: 12px;
                color: #3C3C3C;
                span {
                    padding-left: 10px;
                    a {
                        color: #3C3C3C;
                        text-decoration: underline;
                    }
                }
            }
        }
        .subscription-modal__image {
            img {
                height: 100%;
            }
        }
        .subscription-success {
            text-align: center;
            padding: 20px 0 10px;
            &__title {
                font-size: 20px;
                line-height: 28px;
                font-weight: 510;
                text-transform: uppercase;
                color: #000;
                margin: 0 0 6px;
            }
            &__text {
                margin: 16px 0 0;
                font-size: 16px;
                line-height: 20px;
                text-transform: uppercase;
                color: #000;
            }
        }
    }
}
@media screen and (max-width: 768px) {
    .subscription-modal__form {
        align-items: center;
    }
    .form-header .subscription-modal__title {
        font-size: 14px !important;
    }
    .subscribe-form__checkbox-title {
        font-size: 10px !important;
    }
    .subscription-success {
        &__title {
            font-size: 16px;
            line-height: 22px;
        }
        &__text {
            font-size: 12px;
            line-height: 18px;
        }
    }
}
@media screen and (min-width: 800px) and (max-height: 800px) {
    .picture-wrapper {
        height: 300px;
        img {
            object-fit: contain;
            object-position: top;
        }
    }
}
</style>
